import { AbbreviationSKU } from "@/components/data/AbbreviationSKU";

const find = (key: string) =>
    AbbreviationSKU.find((i) => i.title.toLowerCase() === key.toLowerCase());

export type DecodedPart = {
    key: string;
    value: string;
    sub?: string;
    count?: string;
    hideValue?: boolean;
};

type DecodeSkuResult = {
    raw: string;
    parts: DecodedPart[];
    mode: "managed" | "unmanaged" | "non-switch";
    title: string;
};


const portTypes: {
    type: string;
    regex: RegExp;
    hideValue?: boolean;
}[] = [
    { type: "sfp", regex: /(\d+)sfp/gi },
    { type: "slote1", regex: /(\d+)slote1/gi },
    { type: "e1", regex: /(\d+)e1(?!\w)/gi },
    { type: "ge", regex: /(\d+)ge/gi },
    { type: "fe", regex: /(\d+)fe/gi },
    { type: "xf", regex: /(\d+)xf/gi },
    { type: "tf", regex: /(\d+)tf/gi },
    { type: "bd", regex: /(\d+)bd/gi },
    { type: "sc", regex: /(\d+)sc/gi },
    { type: "rs", regex: /(\d+)rs/gi },
    { type: "g", regex: /(\d+)g/gi },
    { type: "m", regex: /(\d+)m/gi },
    { type: "v", regex: /(\d+)v/gi },
    { type: "s", regex: /(\d+)s(?!fp)/gi },

    { type: "+", regex: /\+/g, hideValue: true,},
];
function parsePorts(part: string) {
    const results: DecodedPart[] = [];
    let remaining = part;
    for (const { type, regex, hideValue } of portTypes) {
        const item = find(type);

        if (!item) continue;

        let match: RegExpExecArray | null;

        while ((match = regex.exec(remaining)) !== null) {
            results.push({
                key: match[0],
                value: item.content,
                sub: item.sub,
                count: match[1] ?? "",
                hideValue,
            });
        }

        remaining = remaining.replace(regex, "");
    }
    return results;
}

export function decodeSku(sku: string): DecodeSkuResult {
    const parts = sku.split("-");

    let hasLayer = false;
    let hasPoe = false;

    const decodedParts: DecodedPart[] = [];

    for (const part of parts) {
        const item = find(part);

        if (item?.group?.includes("managed")) {
            hasLayer = true;
        }

        if (item?.group?.includes("poe")) {
            hasPoe = true;
        }

        // ✅ known dictionary
        if (item) {
            decodedParts.push({
                key: part,
                value: item.content,
                sub: item.sub,
            });
            continue;
        }

        // ports
        const portParts = parsePorts(part);
        if (portParts.length > 0) {
            decodedParts.push(...portParts);
            continue;
        }

        continue;
    }

    if (hasPoe) {
        decodedParts.push({
            key: "poe",
            value: "پشتیبانی از PoE",
            sub: "Power over Ethernet",
        });
    }

    const isSwitch = sku.toLowerCase().includes("sw");

    return {
        raw: sku,
        parts: decodedParts,

        mode: isSwitch
            ? hasLayer
                ? "managed"
                : "unmanaged"
            : "non-switch",

        title:
            decodedParts.map((p) => p.value).join(" / ") +
            (isSwitch
                ? ` / ${hasLayer ? "مدیریتی" : "غیر مدیریتی"}`
                : ""),
    };
}